import { ref } from 'vue'

export const nav_active = ref('home')

export const back_nav = ref('home')